import { Component, Input } from '@angular/core';
import { ButtonType, ElementStatus, Size } from 'src/app/shared/enums';

@Component({
  selector: 'app-btn',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.sass'],
})
export class ButtonComponent {
  buttonType = ButtonType;
  buttonSize = Size;
  buttonColor = ElementStatus;
  @Input() isDisabled = false;
  @Input() isSubmit = false;
  @Input() type: ButtonType = ButtonType.Fill;
  @Input() color: ElementStatus = ElementStatus.Primary;
  @Input() size: Size = Size.Medium;
}
